export default "__VITE_ASSET__BQCjrFUH__"